<template>
  <PulseModal :open="open" style="max-width: 544px" class="ota-modal" @close="$emit('close')">
    <template #header> {{ computedTitle }}</template>

    <section class="text-base text-typography-disabled mb-4">
      <p>{{ computedEligibility }}</p>
    </section>

    <section>
      <p class="text-xs text-typography-disabled">{{ t('disclaimer') }}</p>
    </section>

    <template #footer>
      <PulseButton @click="$emit('close')">{{ t('continue') }}</PulseButton>
    </template>
  </PulseModal>
</template>

<script setup>
const emit = defineEmits(['close']);

const props = defineProps({
  eligibility: {
    default: '',
    type: String,
  },
  open: {
    default: false,
    type: Boolean,
  },
  title: {
    default: '',
    type: String,
  },
});

const computedTitle = computed(() => {
  return props.title || t('title');
});

const computedEligibility = computed(() => {
  return props.eligibility || t('eligibility.p2');
});

const { t } = useI18n({
  useScope: 'local',
});
</script>

<i18n lang="json">
{
  "en": {
    "title": "Good news—You're eligible for a one-time order issue resolution!*",
    "eligibility": {
      "p2": "In order to be eligible to file claims in the future, you'll need to purchase Shipping Protection at checkout."
    },
    "confirmation": "I understand that this is a one-time reimbursement and I will need to purchase Shipping Protection at checkout to be eligible for future claims.",
    "continue": "Continue to file claim",
    "disclaimer": "*For approved claims only."
  }
}
</i18n>
